<template>
<div :class="mainClass" @click="onClick">
    <div class="avatar" :style="style">
        <img :src="avatar"/>
        <br/>
        <span>{{member.name}}</span>
    </div>
</div>
</template>

<script>
  export default {
    props: { member: {
      type: Object,
      required: true
    },
      small: {
        type: Boolean,
        required: true
      },
      swaying: {
        type: Boolean,
        required: true
      }},
    computed: {
      style () {
        let offset = Math.ceil(Math.random() * 20) - 10
        let animtime = 2.5 + Math.random()
        let res = {left: `${offset}px`}
        if (this.swaying) {
          res['animation'] = `swaying ${animtime}s ease-in-out forwards infinite`
        }
        return res
      },
      avatar () {
        if (this.member.img) {
          return this.member.img
        }
        return `https://avatars.io/twitter/${this.member.twitter}/medium`
      },
      mainClass () {
        return 'avatar_container' + (this.small ? ' small' : '') + (this.swaying ? ' swaying' : '')
      }
    },
    methods: {
      onClick () {
        window.open('http://twitter.com/' + this.member.twitter)
      }
    }
  }
</script>

<style>
@-webkit-keyframes swaying {
    0%{-webkit-transform: rotate(10deg);}
    50%{-webkit-transform: rotate(-5deg)}
    100%{-webkit-transform: rotate(10deg);}
}
 
@keyframes swaying {
    0%{transform: rotate(10deg);}
    50%{transform: rotate(-5deg)}
    100%{transform: rotate(10deg);}
}

.avatar_container.small {
    transform: scale(0.7);
}

.avatar_container.swaying {
    transition: all .2s ease-in-out;
}

.avatar_container:hover {
    transform: scale(1.1);
    cursor: pointer;
}

.avatar_container.small:hover {
    transform: scale(0.8);
    cursor: pointer;
}

.avatar {
    width: 164px;
    height: 184px;
    text-align: center;
    font-size: 18px;
    position: relative;
}

.avatar img {
    width: 128px;
    height: 128px;
    border-radius: 10px 10px;
    border: 5px solid rgba(221, 90, 13, 1);
    /* box-shadow: 5px 5px 0px rgba(221, 90, 13, 0.25); */
}
</style>


// WEBPACK FOOTER //
// src/components/Member.vue